import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.14.9_@types+react@19.3.0_next@15.5.27_@babel+core@7.29.7_@types+node@20.19.43_rea_67d5qkbxl2vtxwnoabq52eza24/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.27_@babel+core@7.29.7_@types+node@20.19.43_react-dom@19.3.0_react@19.3.0__react@19.3.0/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\"}],\"variableName\":\"fontSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/provider/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/provider/query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/provider/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsScripts"] */ "/app/src/components/3rd-party-scripts/analytics-scripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScreenDimensionProvider"] */ "/app/src/components/layout/screen-dimension-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TouchableProvider"] */ "/app/src/components/layout/touchable-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PwaInstallationInitialization"] */ "/app/src/components/pwa/pwa-installation-initialization.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/toaster.tsx");
